import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

function CompaniesPage() {
  const history = useHistory();
  const routeMatch = useRouteMatch();

  useEffect(() => {
    if (routeMatch.path === '/app/registry/companies') {
      history.push('/app/registry/companies/list');
    }
  }, [history]);

  return null;
}

export default CompaniesPage;
